/* eslint-disable no-underscore-dangle */
import { apiClient, handleResponse } from './axios';

const formatCourses = (courses) => {
  const formatedCourses = [];
  for (let i = 0; i < courses.length; i += 1) {
    formatedCourses.push({
      label: courses[i].name,
      value: courses[i].name,
      id: courses[i]._id,
    });
  }

  return formatedCourses;
};

async function getAll() {
  try {
    const response = await apiClient.get('/course');
    const courses = await handleResponse(response);
    return formatCourses(courses);
  } catch (error) {
    return error.response;
  }
}

async function getAllWithoutFormat() {
  try {
    const response = await apiClient.get('/course');
    const courses = await handleResponse(response);
    return courses;
  } catch (error) {
    return error.response;
  }
}

async function deleteCourse(id) {
  try {
    const response = await apiClient.delete(`/course/${id}`);
    const courses = await handleResponse(response);
    return courses;
  } catch (error) {
    return error.response;
  }
}

async function updateCourse(id, body) {
  try {
    const response = await apiClient.put(`/course/${id}`, body);
    const courses = await handleResponse(response);
    return courses;
  } catch (error) {
    return error.response;
  }
}

async function addCourse(body) {
  try {
    const response = await apiClient.post('/course', body);
    const courses = await handleResponse(response);
    return courses;
  } catch (error) {
    return error.response;
  }
}

const courseServices = {
  getAll,
  getAllWithoutFormat,
  deleteCourse,
  addCourse,
  updateCourse,
};

export default courseServices;
